import { useReducer } from "react";
import axios from "axios";
import { getBasePath } from "../../Helpers/getEnvVar";
import { getAuthToken } from "../../Helpers/localStorage";

const uploadFaviconHookInitialState = {
  isFetching: false,
  isSuccessful: false,
  errorMessage: "",
  result: {},
};

const uploadFaviconHookReducer = (state, action) => {
  switch (action.type) {
    case "fetching":
      return {
        ...state,
        isFetching: true,
        isSuccessful: false,
        errorMessage: "",
        result: {},
      };
    case "success":
      return {
        ...state,
        isFetching: false,
        isSuccessful: true,
        result: { ...action.payload },
      };
    case "error":
      return {
        ...state,
        isFetching: false,
        isSuccessful: false,
        errorMessage: action.payload,
      };
    default:
      throw new Error("Unsupported Action");
  }
};

const useUploadFavicon = () => {
  const [favicon, dispatch] = useReducer(uploadFaviconHookReducer, uploadFaviconHookInitialState);
  const basePath = getBasePath();

  const setUploadFavicon = ({ userId, image }) => {
    const token = getAuthToken();
    let formData = new FormData();
    formData.append("image", image);
    axios({
      url: `${basePath}/user/${userId}/favicon`,
      method: "POST",
      data: formData,
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    })
      .then((data) => {
        const faviconData = data?.data?.data;
        dispatch({
          type: "success",
          payload: faviconData,
        });
      })
      .catch((err) => {
        dispatch({ type: "error", payload: err?.response?.data?.error });
      });
  };

  const uploadFavicon = (payload) => {
    dispatch({ type: "fetching" });
    setUploadFavicon(payload);
  };

  return [favicon, uploadFavicon];
};

export default useUploadFavicon;
